import "./App.css";
import "./assets/css/custom.css";
import "./assets/css/style.css";
import "./assets/css/frontend.css";
import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./modules/shared/store/sharedSlice";
import { insertUser } from "./modules/myaccount/store/userProfileSlice";
import { Spinner } from "react-bootstrap";
import CreateOrder from "./modules/billing/screens/CreateOrder";
import Login from "./modules/auth/screens/Login";
import AppRouter from "./AppRouter";
import { resetAuth, verifyAccountDetails, verifyUser } from "./modules/auth/store/authSlice";
import { toast, ToastContainer } from "react-toastify";




function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const auth = useSelector((state) => state?.auth);
  const { accessToken, isLoggedIn, verifyAccountStatus } = useSelector((state) => state?.auth);


  const queryParams = new URLSearchParams(window.location.search);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const toastId = useRef(null);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        if (toastId.current) {
          toast.dismiss(toastId.current);
        }
        toastId.current = toast.success("You're back online!");
        setWasOffline(false);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      if (toastId.current) {
        toast.dismiss(toastId.current);
      }
      toastId.current = toast.error("No internet connection!");
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [wasOffline]);



  useEffect(() => {
    const fetchData = async () => {
      const id = queryParams.get("id");
      const name = queryParams.get("name");
      const phone = queryParams.get("phone");
      const authenticateCode = queryParams.get("code");
      const currentTenant = queryParams.get("currentTenant");
      const email = queryParams.get("email");
      const flavor = queryParams.get("flavor");


      if (!id || !authenticateCode) {
        navigate(`/login?${queryParams.toString()}`);
        return;
      }

      const userData = {
        id,
        name,
        phone,
        currentTenant,
        email: email === "null" ? "" : email,
        flavor
      };
      dispatch(resetAuth())
      dispatch(verifyAccountDetails({ code: authenticateCode }));
      dispatch(verifyUser(userData));
    };

    fetchData();
  }, [dispatch]);




  return (
    <>
      <ToastContainer />
      <div
        className="d-flex flex-column flex-root"
        style={{ height: "100vh", overflow: "hidden" }}
      >
        <div className="d-flex flex-column flex-root" style={{ height: "100vh", overflow: "hidden" }}>
          <Suspense
            fallback={
              <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <Spinner animation="border" />
              </div>
            }
          >
            <AppRouter />
          </Suspense>
        </div>
      </div>
    </>
  );
}

export default App;
